import { render } from "./TermsOfUseView.vue?vue&type=template&id=5ec34841&scoped=true"
import script from "./TermsOfUseView.vue?vue&type=script&lang=js"
export * from "./TermsOfUseView.vue?vue&type=script&lang=js"

import "./TermsOfUseView.vue?vue&type=style&index=0&id=5ec34841&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec34841"]])

export default __exports__